import { gql } from '@apollo/client';

export const GET_HOME_PROFILE = gql`
  query GetHomeProfile {
    getMyProfile {
      id
      userId
      displayName
      email
      photoUrl
      hasCompletedOnboarding
      recommendationsEnabled
      updatedAt
    }
  }
`;

export const GET_HOME_SUMMARY = gql`
  query GetHomeSummary($limit: Int) {
    getHomeSummary(limit: $limit) {
      totalEntries
      activeHobbies
      entriesThisWeek
      favoritesCount
      favoritesAddedThisWeek
      currentStreak
      recapPrompt { id period window title subtitle availableUntil }
      fitnessSummary {
        totalWorkouts
        completedWorkouts
        plannedWorkouts
        skippedWorkouts
        workoutsThisWeek
        totalMinutes
        favoriteWorkoutType
        topMuscleGroup
      }
      fitnessRoutineSummary {
        activeRoutines
        scheduledThisWeek
        completedThisWeek
        skippedThisWeek
        missedThisWeek
        remainingThisWeek
        adherenceRate
        previousAdherenceRate
        adherenceDelta
        next { planId planTitle planDayId dayTitle weekday scheduledDate state workoutId }
      }
      hikingSummary {
        totalHikes
        completedHikes
        plannedHikes
        linkedToTrips
        totalDistance
        totalElevationGain
        favoriteTerrain
        favoriteDifficulty
      }
      hobbyBreakdown {
        hobbyId
        hobby
        href
        totalEntries
        entriesThisWeek
        favoritesCount
        latestTitle
        latestAt
        latestTargetType
        latestTargetId
        latestHref
      }
      cards {
        id
        type
        hobbyId
        hobby
        title
        subtitle
        body
        reason
        actionLabel
        actionHref
        targetType
        targetId
        priority
        score
        source
        sourceLabel
        generatedAt
        expiresAt
        createdAt
        action {
          label
          href
          targetType
          targetId
        }
        media {
          type
          url
          alt
          fallback
          cacheKey
        }
        meta {
          label
          value
        }
      }
      cardsPageInfo {
        hasNextPage
        endCursor
      }
      recentItems {
        id
        hobbyId
        hobby
        title
        subtitle
        targetType
        targetId
        href
        media {
          type
          url
          alt
          fallback
          cacheKey
        }
        updatedAt
      }
      discoveryShelves {
        id
        hobbyId
        hobby
        title
        subtitle
        reason
        items {
          id
          type
          hobbyId
          hobby
          title
          subtitle
          body
          reason
          actionType
          actionLabel
          actionHref
          targetType
          targetId
          externalId
          provider
          actionPayload
          score
          source
          sourceLabel
          generatedAt
          expiresAt
          createdAt
          media {
            type
            url
            alt
            fallback
            cacheKey
          }
          meta {
            label
            value
          }
        }
      }
    }
  }
`;

export const DISMISS_INSIGHT_RECAP_PROMPT = gql`
  mutation DismissInsightRecapPrompt($recapId: ID!) {
    dismissInsightRecapPrompt(recapId: $recapId)
  }
`;

export const MARK_INSIGHT_RECAP_SHARED = gql`
  mutation MarkInsightRecapShared($recapId: ID!) {
    markInsightRecapShared(recapId: $recapId)
  }
`;

export const GET_HOME_DISCOVERY_SHELVES = gql`
  query GetHomeDiscoveryShelves {
    getHomeSummary(limit: 1) {
      discoveryShelves {
        id
        hobbyId
        hobby
        title
        subtitle
        reason
        items {
          id
          type
          hobbyId
          hobby
          title
          subtitle
          body
          reason
          actionType
          actionLabel
          actionHref
          targetType
          targetId
          externalId
          provider
          actionPayload
          score
          source
          sourceLabel
          generatedAt
          expiresAt
          createdAt
          media {
            type
            url
            alt
            fallback
            cacheKey
          }
          meta {
            label
            value
          }
        }
      }
    }
  }
`;

export const GET_HOME_FEED_PAGE = gql`
  query GetHomeFeedPage($first: Int, $after: String) {
    getHomeFeedPage(first: $first, after: $after) {
      nodes {
        id
        type
        hobbyId
        hobby
        title
        subtitle
        body
        reason
        actionLabel
        actionHref
        targetType
        targetId
        priority
        score
        source
        sourceLabel
        generatedAt
        expiresAt
        createdAt
        action {
          label
          href
          targetType
          targetId
        }
        media {
          type
          url
          alt
          fallback
          cacheKey
        }
        meta {
          label
          value
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
